export default __webpack_public_path__ + "3a3d32773c7e60a9fee825bd3b953899.png";